var modules_173205eb = {"container":"_fr5kyt","checked":"_9g9ybf","control":"_l4wxnd","disabled":"_1ea5pu1","read-only":"_vub9x","input":"_12ikgoe","label":"_1g2dtnw","icon":"_4d1sni"};
import "../../../assets/BCr4jVEh.css";

export { modules_173205eb as default };
//# sourceMappingURL=Radio.module.less.js.map
